<div class="edit-panel" *ngIf="item">
  <div class="edit-panel-header">
    <div>
      <h6 class="mb-1">Update Patching Info</h6>
      <p class="mb-0">
        Editing <span class="mono">{{ item.hostname || item.instance_name }}</span>
      </p>
    </div>
    <button type="button" class="btn btn-light refresh-btn" (click)="closeEdit()">Cancel</button>
  </div>

  <div class="edit-form-grid">
    <div class="form-group">
      <label class="edit-label">Environment</label>
      <select class="form-control" [(ngModel)]="editForm.environment">
        <option *ngFor="let option of environmentOptions" [value]="option">
          {{ option }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label class="edit-label">Next Patching Date &amp; Time</label>
      <input
        type="datetime-local"
        class="form-control"
        [(ngModel)]="editForm.nextPatchingDateTime"
      />
    </div>

    <div class="form-group full-width">
      <label class="edit-label">To Email Communication</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editForm.toEmailCommunication"
        placeholder="user1@example.com, user2@example.com"
      />
    </div>

    <div class="form-group full-width">
      <label class="edit-label">CC Email Communication</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editForm.ccEmailCommunication"
        placeholder="Leave empty to remove CC emails"
      />
    </div>
  </div>

  <div class="edit-actions">
    <button type="button" class="btn btn-light refresh-btn" (click)="closeEdit()">Cancel</button>
    <button type="button" class="btn update-btn" [disabled]="saving" (click)="updateRecord()">
      {{ saving ? "Updating..." : "Update Record" }}
    </button>
  </div>
</div>
